import { createRouter, createWebHistory } from 'vue-router'
import store from "@/store";
import MeetingView from "@/views/MeetingView.vue";
import InstantMeetingView from "@/views/InstantMeetingView.vue";
import PageNotFound from "@/views/PageNotFound.vue";
import LoginView from "@/views/LoginView.vue";
import InstantMeetingButtonView from "@/views/InstantMeetingButtonView.vue";
import CompleteSignupView from "@/views/CompleteSignupView.vue";
import i18n from "@/i18n";

const routes = [
  {
    path: '/meeting/:id',
    name: 'meeting',
    meta: { noAuth: true },
    component: MeetingView
  },
  {
    path: '/meeting/instant/:id',
    name: 'instantmeeting',
    meta: { noAuth: true, title: "instant.title" },
    component: InstantMeetingView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { noAuth: true },
  },
  {
    path: '/instant',
    name: 'instant',
    meta: { title: "instant.title" },
    component: InstantMeetingButtonView,
  },
  {
    path: '/',
    name: 'instant',
    meta: { title: "instant.title" },
    component: InstantMeetingButtonView,
  },
  {
    path: '/signup/complete',
    name: 'complete',
    meta: { noAuth: true },
    component: CompleteSignupView,
  },
  {
    path: '/:catchAll(.*)*',
    name: "PageNotFound",
    meta: { noAuth: true },
    component: PageNotFound,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    window.document.title = i18n.global.t(to.meta.title)
  }
  if (to.matched.some((record) => record.meta.noAuth)) {
    next();
  } else if (store.state.auth.status.loggedIn) {
      next();
  } else next("/login");
});

export default router
